(function() {
  'use strict';

  angular.module('mgpCorregedoriaApp').config(Configuration);

  Configuration.$inject = ['$httpProvider', 'ngsalConfig'];

  function Configuration($httpProvider, ngsalConfig) {

    var nomeApp = 'mgp-corregedoria';

    ngsalConfig.applicationName = nomeApp;
    ngsalConfig.homePath = 'home';
    ngsalConfig.apiVersion = 'v1';

    $httpProvider.interceptors.push(
      ['$q', 'toaster', function($q, toaster) {

        return {
          'response': function(response) {

            var title = response.headers('title');
            var message = response.headers('message');

            switch (response.status) {
              case 200:
              case 201:
              case 202:
              case 204:
                break;
              default:
                toaster.pop('success', title, message);
            }

            return response;
          },

          'responseError': function(errorResponse) {

            switch (errorResponse.status) {
              case 0:
                toaster.pop('error', 'Desculpe', 'Nossos servidores encontram-se indisponíveis no momento.');
                break;
              case 400:
                angular.forEach(errorResponse.data.violations, function(value) {
                  toaster.pop('warning', nomeApp, value.message);
                });
                //                                toaster.pop('warning', nomeApp, errorResponse.data.error);
                break;
              case 403: // 403-Forbidden - Tem autenticacao, mas, o acesso é proibido para este usuario.
                toaster.pop('warning', nomeApp, 'Você não tem permissão para acessar este conteúdo, ou partes, do conteudo, que foi requisitado.');
                break;
              case 404:
                toaster.pop('info', nomeApp, 'Nenhum registro encontrado');
                break;
              case 409:
                angular.forEach(errorResponse.data.violations, function(value) {
                  toaster.pop('warning', nomeApp, value);
                });
                break;
              case 500:
                //Neste caso o melhor é
                toaster.pop('error', nomeApp, errorResponse.data.error +
                  ' ticket[' + errorResponse.data.ticket + ']', 9000, '');
                break;
              default:
                break;
            }

            return $q.reject(errorResponse);
          }
        };
      }]);
  }


})();
